<template>
  <div class="hardware-card">
    <PagesItemComponentsChildrenThumb
        :fontSize="currW <= 525 ? 12 : 14"
        :item="{} as Item"
        :size="currW <= 525 ? 12 : 16"
        :src="item.image"
        class="hardware-card__image"
    />
    <div class="w-100">
      <p class="hardware-card__label ell">{{ item.type }}</p>
      <a
          :href="item.link"
          class="hardware-card__title ell"
          rel="noopener nofollow noreferrer"
          target="_blank"
      >
        {{ item.title }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {Gear, Item} from "~/graphql/generated/schema-types";

const props = defineProps<{
  item: Gear
}>()

const localePath = useLocalePath()
const currW = useResize()
</script>

<style lang="scss" scoped>
.hardware-card {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 12px;
  background: var(--surfaces-low-container);
  position: relative;

  &__label {
    font-size: 14px;
    color: var(--surfaces-on-surface-variable);
    line-height: 20px;
    width: 100%;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    display: inline-block;
    width: 100%;

    &:after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
    }
  }

  &:deep(.thumb) {
    padding: 0;
    min-height: unset !important;
    width: 140px;
    height: 140px;

    img {
      transition: 0.5s scale;
    }

    .thumb_bg:before {
      content: none;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      min-width: 100%;
      height: unset;
    }
  }

  &:hover,
  &:focus {
    :deep(.thumb) img {
      scale: 1.1;
    }
  }
}
</style>
